import React from 'react'

const SvgHighVoltageOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.934 2h6.329c1.901 0 3.018 2.14 1.933 3.7l-1.977 2.844h1.6c2.093.001 3.066 2.601 1.485 3.975L10 21.48c-1.876 1.63-4.617-.512-3.51-2.724l1.526-3.05H7.13c-1.67 0-2.76-1.744-2.043-3.24l3.71-9.096A2.353 2.353 0 0110.934 2zm-.304 2.172l-3.704 9.079c-.01.023-.02.047-.032.07a.266.266 0 00.237.384l2.504.001a1 1 0 01.894 1.448l-2.25 4.496c-.047.092-.04.147-.031.18a.292.292 0 00.105.148.29.29 0 00.169.066c.033 0 .088-.007.166-.074l10.304-8.96a.247.247 0 00.087-.135.28.28 0 00-.013-.158.279.279 0 00-.093-.128.247.247 0 00-.155-.044l-3.513-.002a1 1 0 01-.82-1.57l3.069-4.414A.356.356 0 0017.262 4h-6.328a.353.353 0 00-.304.172z'
    />
  </svg>
)

export default SvgHighVoltageOutline
